import * as React from 'react';
import { useState, useEffect } from 'react';

import t from './locales';

const CountDown: React.FC<{ cutOffString: string }> = ({ cutOffString }) => {

  let timer = null;
  const [countDownHTML, setCountDownHTML] = useState(null);

  const [year, month, day, hour, minute] = cutOffString.split('-').map(str => Number(str)); // [2019, 10, 31, 23 , 55];
  const timeZoneOffset = 1000 * 60 * 60 * 9;
  const cutOffDate = new Date(Date.UTC(year, month - 1, day, hour, minute, 0) - timeZoneOffset);

  useEffect(() => {
    timer = setInterval(() => {
      const now = new Date();
      const distance = cutOffDate.getTime() - now.getTime();
      const d = Math.floor(distance / (1000 * 60 * 60 * 24));
      const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(timer);
        setCountDownHTML('<span>EXPIRED</span>');
      } else {
        setCountDownHTML(t.countDown({ d, h, m, s }));
      }
    }, 1000);

    return () => {
      if (timer) { clearInterval(timer); }
    }
  }, []);

  return (
    <div>
      {countDownHTML &&
        <span dangerouslySetInnerHTML={{ __html: countDownHTML }} />}
    </div>
  );
}

export default CountDown
